import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, withModifiers as _withModifiers, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-742160ab"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fw-bold mb-5" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-xxl-4" }
const _hoisted_4 = { class: "fw-bold ps-2 fs-7 mb-3" }
const _hoisted_5 = { class: "rounded-4 overflow-hidden border-container me-4" }
const _hoisted_6 = { class: "scroll-container overflow-auto" }
const _hoisted_7 = { class: "break-word" }
const _hoisted_8 = { class: "fs-7 ps-3" }
const _hoisted_9 = { class: "fs-7 ps-2 text-break" }
const _hoisted_10 = {
  key: 0,
  class: "fs-7 ps-2 text-break"
}
const _hoisted_11 = { class: "col-xxl-8" }
const _hoisted_12 = { class: "fw-bold ps-2 fs-7 mb-5 mt-5 mt-xxl-0" }
const _hoisted_13 = { class: "d-flex px-4 mb-4 totalValue" }
const _hoisted_14 = { class: "my-auto mx-auto" }
const _hoisted_15 = { class: "fs-7 fw-bold" }
const _hoisted_16 = {
  key: 0,
  class: "fw-bold"
}
const _hoisted_17 = {
  key: 1,
  class: "fw-bold"
}
const _hoisted_18 = { class: "row mx-lg-0 px-lg-0 pb-2 pb-lg-4 gx-3 mb-3 mb-lg-5" }
const _hoisted_19 = { class: "w-max-content col-lg-2 col-form-label fs-7 fw-bold" }
const _hoisted_20 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_21 = { class: "row mx-0 px-0 col-lg-9" }
const _hoisted_22 = { class: "col-lg-12" }
const _hoisted_23 = { class: "d-flex fs-7" }
const _hoisted_24 = ["placeholder"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mt-2 ms-2" }, "pt", -1))
const _hoisted_26 = {
  key: 0,
  class: "invalid-error"
}
const _hoisted_27 = {
  key: 1,
  class: "invalid-error"
}
const _hoisted_28 = {
  key: 2,
  class: "invalid-error"
}
const _hoisted_29 = {
  key: 3,
  class: "invalid-error"
}
const _hoisted_30 = { class: "mt-2 fs-7" }
const _hoisted_31 = { class: "fw-bold" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " pt ( =", -1))
const _hoisted_33 = { class: "fw-bold" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " pt × ", -1))
const _hoisted_35 = { class: "fw-bold" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " ユーザ )", -1))
const _hoisted_37 = {
  key: 0,
  class: "invalid-error alert alert-danger mb-2 w-75"
}
const _hoisted_38 = { class: "row mx-0 px-0 d-flex justify-content-center" }
const _hoisted_39 = { class: "col-lg-6 d-flex justify-content-lg-end justify-content-center mb-4 mb-lg-0" }
const _hoisted_40 = { class: "col-lg-6 d-flex justify-content-lg-start justify-content-center" }
const _hoisted_41 = {
  class: "modal fade",
  id: "modalConfirm",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_42 = { class: "modal-dialog modal-xl" }
const _hoisted_43 = { class: "modal-content" }
const _hoisted_44 = { class: "modal-header" }
const _hoisted_45 = { class: "modal-title w-100 fw-bold text-center" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_47 = { class: "row" }
const _hoisted_48 = { class: "col-xxl-6" }
const _hoisted_49 = { class: "fw-bold ps-2 fs-7 mb-3" }
const _hoisted_50 = { class: "rounded-4 overflow-hidden border-container me-4" }
const _hoisted_51 = { class: "scroll-container overflow-auto" }
const _hoisted_52 = { class: "break-word" }
const _hoisted_53 = { class: "fs-7 ps-3" }
const _hoisted_54 = { class: "fs-7 ps-2 text-break" }
const _hoisted_55 = {
  key: 0,
  class: "fs-7 ps-2 text-break"
}
const _hoisted_56 = { class: "col-xxl-6" }
const _hoisted_57 = { class: "d-flex px-4 mb-4 totalValue mt-5 mt-xxl-0" }
const _hoisted_58 = { class: "my-auto mx-auto" }
const _hoisted_59 = { class: "fw-bold fs-7" }
const _hoisted_60 = { class: "fw-bold" }
const _hoisted_61 = { class: "row mx-lg-0 px-lg-0 pb-2 pb-lg-4 gx-3 mb-3 mb-lg-5" }
const _hoisted_62 = { class: "w-max-content col-lg-3 col-form-label fw-bold fs-7" }
const _hoisted_63 = { class: "row mx-0 px-0 col-lg-9 mt-2" }
const _hoisted_64 = { class: "col-lg-12 fs-7 text-break" }
const _hoisted_65 = { class: "break-word" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " pt", -1))
const _hoisted_67 = { class: "fw-bold" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " pt ( =", -1))
const _hoisted_69 = { class: "fw-bold" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " pt ×", -1))
const _hoisted_71 = { class: "fw-bold" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " ユーザ )", -1))
const _hoisted_73 = { class: "mb-5 mt-2 d-flex justify-content-center fs-7 fw-bold" }
const _hoisted_74 = { class: "modal-footer d-flex justify-content-center" }
const _hoisted_75 = { class: "row mx-0 px-0 d-flex justify-content-center" }
const _hoisted_76 = { class: "col-lg-6 d-flex justify-content-lg-end justify-content-center mb-4 mb-lg-0" }
const _hoisted_77 = { class: "col-lg-6 d-flex justify-content-lg-start justify-content-center" }
const _hoisted_78 = {
  class: "modal fade",
  id: "modalFinish",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true",
  "data-bs-keyboard": "false",
  "data-bs-backdrop": "static"
}
const _hoisted_79 = { class: "modal-dialog" }
const _hoisted_80 = { class: "modal-content" }
const _hoisted_81 = { class: "modal-header" }
const _hoisted_82 = { class: "modal-title w-100 fw-bold text-center" }
const _hoisted_83 = { key: 0 }
const _hoisted_84 = { class: "bg-light py-3 ps-3 pe-2 m-4" }
const _hoisted_85 = { class: "me-2" }
const _hoisted_86 = /*#__PURE__*/_createTextVNode()
const _hoisted_87 = { class: "text-center m-4 break-word" }
const _hoisted_88 = { class: "modal-footer d-flex justify-content-center" }

import { ref, computed, onMounted, nextTick } from 'vue'
import Breadcrumb from '@/components/breadcrumb/index.vue'
import Button from '@/components/button/index.vue'
import { numberWithCommas } from '@/constants/common.ts'
import { translate } from '@/languages/i18n'
import { Modal } from 'bootstrap'
import { useStore } from 'vuex'
import UserAliasIcon from '@/components/user-alias-icon/index.vue'
import { COMMUNITY_ALUMNUS_STORE, CONVERSATIONS_STORE } from '@/store/constants'
import { useRoute, useRouter } from 'vue-router'
import { required, integer, between } from '@vuelidate/validators'
import useVuelidate from '@vuelidate/core'
import grantedPointsServices from '@/services/granted-points.services'
import Status from '@/components/status/index.vue'
import { REGEX_NUMERIC } from '@/constants/regex'
import Loading from '@/components/loading/index.vue'
import { scrollToErrors } from '@/utils'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const route = useRoute()
const router = useRouter()
const listRecordSelected = computed(() => store.getters[COMMUNITY_ALUMNUS_STORE.GETTERS.GET_LIST_RECORD_SELECTED])
const modal = ref()
const dataTotalPoints = ref()
const ErrorPoint = ref(false)
const loadingSubmit = ref(false)
const loading = ref(false)

// 2022/10/13 TuanTT Validate input start with zero number UAT#4409: OE56(Ph2-R20221021)
const totalPoint = computed(() => numberWithCommas(Number(formData.value.point_grant_logs * listRecordSelected.value?.length)))
const pointGrantLogs = computed(() => numberWithCommas(Number(formData.value.point_grant_logs)))
const breadcrumb = [
  {
    content: translate('CC10home'),
    to: `/community/communities/${route.params?.id}/dashboard`,
    active: false,
  },
  {
    content: translate('OE30userManagement'),
    to: ``,
    active: false,
  },
  {
    content: translate('OE50breadcrumbAlumnus'),
    to: `/community/communities/${route.params?.id}/alumnus?management_no=desc`,
    active: false,
  },
  {
    content: translate('OE56title'),
    to: '',
    active: true,
  },
]
const formData = ref({
  point_grant_logs: 0,
  point_logs: '',
})
const rules = computed(() => {
  return {
    point_grant_logs: {
      required,
      integer,
      ownedPoint: function (value) {
        return !(dataTotalPoints.value < value * listRecordSelected.value?.length)
      },
      between: between(1, 999999),
      zero: (value: any) => !`${value}`.startsWith('0'), // 2022/10/13 TuanTT Validate input start with zero number UAT#4409: OE56(Ph2-R20221021)
    },
  }
})
const v$ = useVuelidate(rules, formData)
// 2022/10/25 CW-VietNC Fix for UAT Phase2#4782: OE56 fix point undefined (Ph2-R202201104)
onMounted(async () => {
  loading.value = true
  try {
    const res = await grantedPointsServices.getPointsTotal(route.params.id)
    if (res.data?.success) {
      dataTotalPoints.value = res?.data.data.points
    }
  } catch (error) {
    console.log(error)
  }
  loading.value = false
})
onMounted(() => {
  modal.value = new Modal(document.getElementById('modalConfirm'))
})
const modalFinish = ref()
const dataReturn = ref([])
const hanldeErrorServer = ref(false)
onMounted(() => {
  modalFinish.value = new Modal(document.getElementById('modalFinish'))
})

const onSubmitFinish = async (): void => {
  loadingSubmit.value = true
  try {
    const management_no = listRecordSelected.value.map(function (obj) {
      return obj['management_no']
    })
    const response = await grantedPointsServices.createPoints(route.params.id, {
      management_no: management_no,
      points: formData.value.point_grant_logs,
    })
    dataReturn.value = response?.data?.data
    if (response.status === 200) {
      hanldeErrorServer.value = false
      ErrorPoint.value = false
      modalFinish.value.show()
      modal.value.hide()
    } else if (response?.response?.status === 400 && response?.response?.data?.data[0]?.message_code === 'VALIDATE_OWNED_POINTS') {
      ErrorPoint.value = true
      modalFinish.value.show()
      modal.value.hide()
    } else {
      hanldeErrorServer.value = true
      modalFinish.value.show()
      modal.value.hide()
    }
    setTimeout(() => {
      loadingSubmit.value = false
    }, 500)
  } catch (error) {
    console.log(error)
    ErrorPoint.value = true
    hanldeErrorServer.value = true
    modalFinish.value.show()
    modal.value.hide()
    loadingSubmit.value = false
  }
}
onMounted(() => {
  if (listRecordSelected.value?.length === 0) {
    router.push(`/community/communities/${route.params?.id}/alumnus?management_no=desc`)
  }
})
const onSubmit = () => {
  v$.value.$touch()
  if (v$.value.$invalid) {
    nextTick(() => {
      scrollToErrors('.invalid-error')
    })
    return
  }

  if (!v$.value.$invalid) {
    modal.value?.show()
  }
}
const BackPreviousPage = () => {
  // 2022/11/02 TienNV Fix bug selected user disappears when back previous page  UAT#4500: OE56(Ph2-R20221104)
  const payload = {
    typeData: 'alumni',
    type: 'checkAll',
    data: listRecordSelected.value,
  }
  store.dispatch(CONVERSATIONS_STORE.ACTIONS.CHECK_ALL_MANAGEMENT_NO, payload)
  router.go(-1)
}
const transitToSelect = () => {
  store.dispatch(CONVERSATIONS_STORE.ACTIONS.SET_DATA_SEARCH_DETAIL, { typeData: 'clearData', data: [] })
  store.dispatch(COMMUNITY_ALUMNUS_STORE.ACTIONS.SET_DATA_SEARCH_ALUMNUS, [])
  router.push(`/community/communities/${route.params?.id}/alumnus?management_no=desc`)
}
const checkMessage = () => {
  if (!hanldeErrorServer.value && !ErrorPoint.value) {
    return 'OE65registered'
  } else if (!hanldeErrorServer.value && ErrorPoint.value) {
    return 'OE65errorPoint'
  } else if (hanldeErrorServer.value && !ErrorPoint.value) {
    return 'OE65registeredFail'
  }
}

// 2022/10/12 PhucNV Fix bug input only numberic UAT#4429: OE10,OE12,OE56(Ph2-R20221014)
const onlyNumberKey = (event) => {
  let char = String.fromCharCode(event.keyCode)
  if (!REGEX_NUMERIC.test(char) || event.target.value.length > 5) {
    event.preventDefault()
  }
}

const onlyPasteNumber = (event) => {
  let copiedText = event.clipboardData.getData('text')
  if (!REGEX_NUMERIC.test(copiedText) || copiedText.length + event.target.value.length > 6) {
    event.preventDefault()
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Breadcrumb, {
      breadcrumb: breadcrumb,
      class: "mx-0"
    }),
    _createElementVNode("form", {
      onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
      class: "bg-white rounded-4 shadow p-4 mb-4"
    }, [
      _createElementVNode("h1", _hoisted_1, _toDisplayString(_unref(translate)('OE56title')), 1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h2", _hoisted_4, _toDisplayString(_unref(numberWithCommas)(_unref(listRecordSelected)?.length)) + "件のユーザを選択中", 1),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(listRecordSelected), (user) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: user,
                  class: "d-flex px-3 py-2 display_management"
                }, [
                  _createVNode(UserAliasIcon, {
                    userType: user?.user_type
                  }, null, 8, ["userType"]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("span", _hoisted_8, _toDisplayString(user.management_no), 1),
                    _createElementVNode("span", _hoisted_9, _toDisplayString(user.family_name) + " " + _toDisplayString(user.given_name), 1),
                    (_unref(route)?.query?.user_type !== '1')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, "(" + _toDisplayString(user.display_name) + ")", 1))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("h2", _hoisted_12, _toDisplayString(_unref(translate)('OE56titleRight')), 1),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("p", _hoisted_14, [
              _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(translate)('OE56totalValue')), 1),
              (dataTotalPoints.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(' ' + _unref(numberWithCommas)(dataTotalPoints.value)) + " pt", 1))
                : _createCommentVNode("", true),
              (dataTotalPoints.value === 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_17, " 0 pt"))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("label", _hoisted_19, _toDisplayString(_unref(translate)('OE56label')), 1),
            _createElementVNode("div", _hoisted_20, [
              _createVNode(Status)
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_23, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      name: "title",
                      min: "0",
                      max: "999999",
                      onKeypress: _cache[0] || (_cache[0] = ($event: any) => (onlyNumberKey($event))),
                      onPaste: _cache[1] || (_cache[1] = ($event: any) => (onlyPasteNumber($event))),
                      class: _normalizeClass(['form-control fs-7 point-input', _unref(v$).point_grant_logs?.$error ? 'is-invalid' : '']),
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).point_grant_logs.$model) = $event)),
                      placeholder: _unref(translate)('placeholder')
                    }, null, 42, _hoisted_24), [
                      [
                        _vModelText,
                        _unref(v$).point_grant_logs.$model,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _hoisted_25
                  ]),
                  _createElementVNode("div", null, [
                    (_unref(v$).point_grant_logs.$errors[0]?.$validator === 'required')
                      ? (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(_unref(translate)('OE56requiredInput')), 1))
                      : _createCommentVNode("", true),
                    (_unref(v$).point_grant_logs.$errors[0]?.$validator === 'between')
                      ? (_openBlock(), _createElementBlock("p", _hoisted_27, _toDisplayString(_unref(translate)('OE56minMaxString', _unref(translate)(`OE56titleValidator`), [1, _unref(numberWithCommas)(999999)])), 1))
                      : _createCommentVNode("", true),
                    (_unref(v$).point_grant_logs.$errors[0]?.$validator === 'integer')
                      ? (_openBlock(), _createElementBlock("p", _hoisted_28, _toDisplayString(_unref(translate)('OE56validatorInteger')), 1))
                      : _createCommentVNode("", true),
                    (_unref(v$).point_grant_logs.$errors[0]?.$validator === 'zero')
                      ? (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString(_unref(translate)('OE56validatorPointStartWithZero')), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("p", _hoisted_30, [
                    _createElementVNode("span", null, _toDisplayString(_unref(translate)('OE65points')), 1),
                    _createElementVNode("span", _hoisted_31, _toDisplayString(' ' + _unref(totalPoint)), 1),
                    _hoisted_32,
                    _createElementVNode("span", _hoisted_33, _toDisplayString(' ' + _unref(pointGrantLogs)), 1),
                    _hoisted_34,
                    _createElementVNode("span", _hoisted_35, _toDisplayString(_unref(numberWithCommas)(_unref(listRecordSelected)?.length)), 1),
                    _hoisted_36
                  ])
                ])
              ])
            ]),
            (_unref(v$).point_grant_logs.$errors[0]?.$validator === 'ownedPoint')
              ? (_openBlock(), _createElementBlock("p", _hoisted_37, _toDisplayString(_unref(translate)('VALIDATE_OWNED_POINTS')), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_38, [
        _createElementVNode("div", _hoisted_39, [
          _createVNode(Button, {
            title: _unref(translate)('back'),
            type: 'secondary',
            className: 'fw-bold',
            onClick: BackPreviousPage
          }, null, 8, ["title"])
        ]),
        _createElementVNode("div", _hoisted_40, [
          _createVNode(Button, {
            title: _unref(translate)('confirm'),
            type: 'secondary',
            className: 'fw-bold',
            onClick: onSubmit
          }, null, 8, ["title"])
        ])
      ])
    ], 32),
    _createElementVNode("div", _hoisted_41, [
      _createElementVNode("div", _hoisted_42, [
        _createElementVNode("div", _hoisted_43, [
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("h5", _hoisted_45, _toDisplayString(_unref(translate)('OE56titleConfirm')), 1),
            _hoisted_46
          ]),
          _createElementVNode("form", {
            onSubmit: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"])),
            class: "bg-white rounded-4 shadow p-4"
          }, [
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("h2", _hoisted_49, _toDisplayString(_unref(numberWithCommas)(_unref(listRecordSelected)?.length)) + "件のユーザを選択中", 1),
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(listRecordSelected), (user) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: user,
                        class: "d-flex px-3 py-2 display_management"
                      }, [
                        _createVNode(UserAliasIcon, {
                          userType: user?.user_type
                        }, null, 8, ["userType"]),
                        _createElementVNode("div", _hoisted_52, [
                          _createElementVNode("span", _hoisted_53, _toDisplayString(user.management_no), 1),
                          _createElementVNode("span", _hoisted_54, _toDisplayString(user.family_name) + " " + _toDisplayString(user.given_name), 1),
                          (_unref(route)?.query?.user_type !== '1')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_55, "(" + _toDisplayString(user.display_name) + ")", 1))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("p", _hoisted_58, [
                    _createElementVNode("span", _hoisted_59, _toDisplayString(_unref(translate)('OE56totalValue')), 1),
                    _createElementVNode("span", _hoisted_60, _toDisplayString(' ' + _unref(numberWithCommas)(dataTotalPoints.value)) + " pt", 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_61, [
                  _createElementVNode("label", _hoisted_62, _toDisplayString(_unref(translate)('OE56label')), 1),
                  _createElementVNode("div", _hoisted_63, [
                    _createElementVNode("div", _hoisted_64, [
                      _createElementVNode("p", null, [
                        _createElementVNode("span", _hoisted_65, _toDisplayString(_unref(numberWithCommas)(formData.value?.point_grant_logs)), 1),
                        _hoisted_66
                      ]),
                      _createElementVNode("p", null, [
                        _createElementVNode("span", null, _toDisplayString(_unref(translate)('OE65points')), 1),
                        _createElementVNode("span", _hoisted_67, _toDisplayString(' ' + _unref(numberWithCommas)(formData.value?.point_grant_logs * _unref(listRecordSelected)?.length)), 1),
                        _hoisted_68,
                        _createElementVNode("span", _hoisted_69, _toDisplayString(' ' + _unref(numberWithCommas)(formData.value?.point_grant_logs)), 1),
                        _hoisted_70,
                        _createElementVNode("span", _hoisted_71, _toDisplayString(_unref(numberWithCommas)(_unref(listRecordSelected)?.length)), 1),
                        _hoisted_72
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_73, _toDisplayString(_unref(translate)('OE56textConfirm')), 1),
            _createElementVNode("div", _hoisted_74, [
              _createElementVNode("div", _hoisted_75, [
                _createElementVNode("div", _hoisted_76, [
                  _createVNode(Button, {
                    title: _unref(translate)('cancel'),
                    type: 'secondary',
                    "data-bs-dismiss": "modal",
                    className: 'fw-bold'
                  }, null, 8, ["title"])
                ]),
                _createElementVNode("div", _hoisted_77, [
                  _createVNode(Button, {
                    title: _unref(translate)('OE65Grant'),
                    type: 'secondary',
                    className: 'fw-bold',
                    onClick: onSubmitFinish,
                    loading: loadingSubmit.value,
                    disabled: loadingSubmit.value
                  }, null, 8, ["title", "loading", "disabled"])
                ])
              ])
            ])
          ], 32)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_78, [
      _createElementVNode("div", _hoisted_79, [
        _createElementVNode("div", _hoisted_80, [
          _createElementVNode("div", _hoisted_81, [
            _createElementVNode("h5", _hoisted_82, _toDisplayString(_unref(translate)('OE56titleSucces')), 1)
          ]),
          (dataReturn.value?.data_failed?.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                _createElementVNode("div", _hoisted_84, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataReturn.value?.data_failed, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "mb-2 d-flex align-items-center",
                      key: index
                    }, [
                      _createVNode(UserAliasIcon, {
                        userType: _unref(route)?.query?.user_type === '1' ? 1 : 2
                      }, null, 8, ["userType"]),
                      _createElementVNode("span", _hoisted_85, _toDisplayString(item?.management_no), 1),
                      _hoisted_86,
                      _createElementVNode("span", null, _toDisplayString(_ctx.renderName(item?.management_no)), 1)
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_87, _toDisplayString(_unref(translate)(checkMessage())), 1),
          _createElementVNode("div", _hoisted_88, [
            _createVNode(Button, {
              title: _unref(translate)('OE65registeredFooter'),
              type: 'secondary',
              "data-bs-dismiss": "modal",
              onClick: transitToSelect
            }, null, 8, ["title"])
          ])
        ])
      ])
    ]),
    _createVNode(Loading, { loading: loading.value }, null, 8, ["loading"])
  ], 64))
}
}

})